/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, {
  FC,
  ReactElement,
  useState,
  useEffect,
  useCallback,
  useRef,
} from 'react';
import DatePicker from 'react-datepicker';
import Flatpickr from 'react-flatpickr';
import { connect, useSelector } from 'react-redux';
import { clearEventsErrors as clearEventsErrorsAction } from 'actions/events';
import { createEventErrorsSelector } from 'selectors/events';
import { getTimeWithTimeZone, getUtcTime } from 'utils/helpers/momentTime';
import _ from 'lodash';
import { IEvents, IScholarsState, IEventsState } from 'types';
import moment from 'moment';
import { IRootState } from 'store';
import Dialog from '@material-ui/core/Dialog';
import buttons from 'style/buttons.module.scss';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import 'react-datepicker/dist/react-datepicker.css';
import 'reactjs-popup/dist/index.css';
import Close from 'style/imgs/icons/close-icon.svg';
import Delete from 'style/imgs/icons/delete-icon.svg';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import IconCalendar from 'style/imgs/calendar/Calendar.svg';
import IconLocation from 'style/imgs/calendar/Location.svg';
import IconTick from 'style/imgs/calendar/Tick.svg';
import IconTime from 'style/imgs/calendar/Time.svg';
import IconLink from 'style/imgs/calendar/link.svg';
import ReccModal from 'components/common/modal/modal';
import './modal.scss';
import { EventTypes, TypesList } from 'utils/constants/eventTypes';
import RecurringModal from './recurringModal';
import styles from './index.module.scss';
import ArrowIcon from './arrowIcon';
import Logger from '../helpers/devConsoleLog';

const mapStateToProps = (state: IRootState) => ({
  eventsData: state.events,
  scholars: state.scholars,
  activeScholarId: state.users.userData?.activeScholarId,
});
interface IModalProps {
  trigger?: ReactElement;
  addEvent: (data: IEvents, unitId: number, onSuccess?: () => void) => void;
  editEvent?: (
    unitId: number,
    eventId: number,
    data: IEvents,
    onSuccess?: () => void,
    repeatAction?: string
  ) => void;
  deleteEvent?: (
    unitId: number,
    eventId: number,
    repeatAction?: string
  ) => void;
  clearEventsErrors?: () => void;
  day?: moment.Moment;
  time?: string;
  isModalOpen?: boolean;
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  editEventData?: IEvents;
  eventsData: IEventsState;
  scholars: IScholarsState;
  activeScholarId: number | undefined;
}
const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      margin: '0px !important',
      minWidth: 120,
      width: '100%',
      height: 40,
      border: '1px solid #E8E7EC !important',
      boxSizing: 'border-box',
      borderRadius: 100,
      color: '#BBB6C5',
      fontSize: '16px',
    },
    selectEmpty: {},
  })
);

const Modal: FC<IModalProps> = ({
  trigger,
  addEvent,
  day,
  time,
  isModalOpen,
  setIsModalOpen,
  editEventData,
  editEvent,
  deleteEvent,
  scholars,
  clearEventsErrors,
  activeScholarId,
}) => {
  const errorMessages = useSelector(createEventErrorsSelector);
  const [hasError, setError] = useState(true);
  const [eventName, setEventName] = useState('Social and Emotional');
  const [repeatability, setRepeatability] = useState('');
  const [lesson, setLesson] = useState('');
  const [startTime, setStartTime] = useState(
    moment(time, 'LT').format('HH:mm')
  );
  const [endTime, setEndTime] = useState(moment(time, 'LT').format('HH:mm'));
  const [startDate, setStartDate] = useState(moment(day).toDate());
  const [endDate, setEndDate] = useState(moment(day).add(1, 'days').toDate());
  const [occurrences, setOccurrences] = useState('1');
  const [link, setLink] = useState('');
  const [isOnline, setIsOnline] = useState(false);
  const classes = useStyles();

  const [isReccurrentDeleteOpen, setReccurrentDeleteOpen] = useState(false);
  const handleOpenDelete = () =>
    setReccurrentDeleteOpen(!isReccurrentDeleteOpen);
  const [isReccurrentEditOpen, setReccurrentEditOpen] = useState(false);
  const handleOpenEdit = () => setReccurrentEditOpen(!isReccurrentEditOpen);

  useEffect(() => {
    if (editEventData) {
      setStartTime(
        getTimeWithTimeZone(editEventData.startTimeStr || '00:00', 'HH:mm')
      );
      setEndTime(
        getTimeWithTimeZone(editEventData.endTimeStr || '00:00', 'HH:mm')
      );
      setEventName(editEventData.title);
      setLesson(editEventData.subject);
      setLink(editEventData.link || '');
      setStartDate(moment(editEventData.startTime).toDate());
      setIsOnline(editEventData.isOnline);
    }
  }, [editEventData, time, isModalOpen]);

  useEffect(() => {
    if (!editEventData) {
      setEventName('');
      setLesson('');
      setLink('');
      setRepeatability('');
      setEndDate(moment(day).add(1, 'days').toDate());
      setOccurrences('1');
      setStartDate(moment(day).toDate());
      setStartTime(moment(time, 'LT').format('HH:mm'));
      setEndTime(moment(time, 'LT').add(15, 'm').format('HH:mm'));
      setIsOnline(false);
    }
  }, [day, time, isModalOpen, editEventData]);

  const handleClickOpen = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (setIsModalOpen) {
      setIsModalOpen(true);
    }
  };

  const handleClose = useCallback(() => {
    if (setIsModalOpen && clearEventsErrors) {
      setIsModalOpen(false);
      clearEventsErrors();
    }
  }, [clearEventsErrors, setIsModalOpen]);

  const handleStartTime = (val: Date[]) => {
    if (val) {
      setStartTime(moment(val[0]).format('HH:mm'));
    }
  };

  const handleEndTime = (val: Date[]) => {
    if (val) {
      setEndTime(moment(val[0]).format('HH:mm'));
    }
  };

  const calculateOccurrents = useCallback(
    (daysDiff) => {
      if (repeatability === 'daily') {
        setOccurrences(daysDiff.toString());
      } else if (repeatability === 'weekly') {
        setOccurrences(`${(daysDiff / 7).toFixed(0)}`);
      } else if (repeatability === 'bi-weekly') {
        setOccurrences(`${(daysDiff / 14).toFixed(0)}`);
      }
    },
    [repeatability]
  );

  const handleEndDate = (date: Date) => {
    const daysDiff = moment(date).diff(moment(startDate), 'days');
    setEndDate(date);
    calculateOccurrents(daysDiff < 1 ? 1 : daysDiff + 1);
  };
  const handleStartDate = (date: Date) => {
    const daysDiff = moment(endDate).diff(moment(date), 'days');
    setStartDate(date);
    calculateOccurrents(daysDiff < 1 ? 1 : daysDiff + 1);
  };

  const handleSetOccurrences = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let occ = e.target.value;
      if (repeatability === 'weekly') {
        occ = (+e.target.value * 7).toFixed(0);
      } else if (repeatability === 'bi-weekly') {
        occ = (+e.target.value * 14).toFixed(0);
      }
      const daysCount = +occ > 0 ? +occ - 1 : 0;
      const date = moment(startDate).add(daysCount, 'days').toDate();
      setOccurrences(e.target.value);
      setEndDate(date);
    },
    [repeatability, startDate]
  );

  const onSuccess = () => setError(false);

  useEffect(() => {
    if (!hasError) {
      handleClose();
    }
    return () => setError(true);
  }, [handleClose, hasError]);

  const startTimePickerRef = useRef<Flatpickr>(null);
  const endTimePickerRef = useRef<Flatpickr>(null);

  const handleSubmit = async (type?: string) => {
    // TS can't see node inside of Flatpickr ref
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const startTPref = startTimePickerRef.current as any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const endTPref = endTimePickerRef.current as any;

    // Use latest value from Flatpickr ref or the value from state
    const startT = startTPref?.node?.value || startTime;
    const endT = endTPref?.node?.value || endTime;

    const data = {
      title: eventName,
      subject: lesson as EventTypes,
      startTime: getUtcTime(startT, 'LT', startDate),
      endTime: getUtcTime(endT, 'LT', startDate),
      link: link.trim() || null,
      repeat: repeatability,
      isOnline,
      date: startDate.toISOString(),
      to: moment(endDate).format('YYYY-MM-DD 00:00'),
    };

    if (!activeScholarId) {
      Logger(
        'handleSubmit failed, no active scholars. activeScholarId is:',
        activeScholarId
      );
      return;
    }

    if (!editEventData) {
      await addEvent(data, activeScholarId, onSuccess);

      if (!_.isEmpty(scholars.units) && !hasError) {
        setEventName('');
        setLink('');
        setLesson('');
        setEndDate(moment(day).add(1, 'days').toDate());
        setOccurrences('1');
        handleClose();
      }
    } else if (editEvent && editEventData.id) {
      await editEvent(activeScholarId, editEventData.id, data, onSuccess, type);

      if (!_.isEmpty(scholars.units) && !hasError) {
        handleClose();
      }
    }
  };

  const handleSetEditType = (type: string) => {
    handleSubmit(type);
    handleOpenEdit();
  };
  const handleChangeRepeatability = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setRepeatability(event.target.value as string);
  };
  const handleChangeLesson = (event: React.ChangeEvent<{ value: unknown }>) => {
    setLesson(event.target.value as string);
  };
  const handleChangeName = (event: React.ChangeEvent<{ value: unknown }>) => {
    setEventName(event.target.value as string);
  };
  const handleSetLink = (event: React.ChangeEvent<{ value: unknown }>) => {
    setLink(event.target.value as string);
    if (event.target.value !== '') {
      setIsOnline(true);
    } else {
      setIsOnline(false);
    }
  };
  const handleDeleteEvent = (type?: string) => {
    if (editEventData?.id && deleteEvent && activeScholarId) {
      deleteEvent(activeScholarId, editEventData.id, type);
      setReccurrentDeleteOpen(false);
      handleClose();
    }
  };
  const options = {
    enableTime: true,
    inline: true,
    noCalendar: true,
    dateFormat: 'H:i',
  };

  return (
    <div>
      <div
        role="button"
        onKeyDown={() => handleClickOpen}
        tabIndex={0}
        onClick={handleClickOpen}
      >
        {trigger}
      </div>
      <Dialog open={isModalOpen!} onClose={handleClose}>
        <div className={styles.modalAddEvent}>
          <div className={styles.modalClose}>
            <button type="button" onClick={handleClose}>
              <img src={Close} alt="" />
            </button>
          </div>
          <div
            style={repeatability ? { marginBottom: '18px' } : {}}
            className={styles.inputWrapper}
          >
            <input
              type="text"
              value={eventName}
              placeholder="Add Event Name"
              onChange={handleChangeName}
              className={`${styles.customSelectTime} ${styles.margin}`}
            />
          </div>
          <div
            style={repeatability ? { marginBottom: '10px' } : {}}
            className={styles.customSelect}
          >
            {repeatability && !editEventData && (
              <span className={styles.placeholder}>Start Date</span>
            )}
            <DatePicker
              className="input-picker"
              selected={startDate}
              onChange={handleStartDate}
              disabledKeyboardNavigation
              disabled={!!(editEventData && editEventData.repeat)}
              dateFormat="d MMM, yyyy"
            />
            <img src={IconCalendar} alt="" />
          </div>
          {repeatability !== '' && !editEventData && (
            <>
              <div
                style={repeatability ? { marginBottom: '10px' } : {}}
                className={styles.customSelect}
              >
                <span className={styles.placeholder}>End Date</span>
                <DatePicker
                  className="input-picker"
                  selected={endDate}
                  onChange={handleEndDate}
                  disabledKeyboardNavigation
                  dateFormat="d MMM, yyyy"
                />
                <img src={IconCalendar} alt="" />
              </div>
              <div className={styles.inputWrapper}>
                <span className={styles.placeholder}>Occurrences</span>
                <input
                  type="number"
                  name="Occurrences"
                  value={occurrences}
                  placeholder="Occurrences"
                  onChange={handleSetOccurrences}
                  className={`${styles.customSelectTime} ${styles.margin}`}
                />
              </div>
            </>
          )}
          <div className={`${styles.customSelectTime} ${styles.margin}`}>
            <img src={IconTime} alt="" />
            <div>
              <Flatpickr
                options={options}
                value={
                  new Date(
                    `${moment(startDate).format('YYYY-MM-DD')}, ${startTime}`
                  )
                }
                onChange={(val) => handleStartTime(val)}
                ref={startTimePickerRef}
              />{' '}
              <Flatpickr
                options={options}
                value={
                  new Date(
                    `${moment(startDate).format('YYYY-MM-DD')}, ${endTime}`
                  )
                }
                onChange={(val) => handleEndTime(val)}
                ref={endTimePickerRef}
              />
            </div>
          </div>
          <div className={`${styles.customSelect} ${styles.margin}`}>
            <img src={IconLocation} alt="" />
            <FormControl className={classes.formControl}>
              <Select
                value={lesson}
                onChange={handleChangeLesson}
                displayEmpty
                className={`${classes.selectEmpty} ${styles.capitalize}`}
                inputProps={{ 'aria-label': 'Without label' }}
                IconComponent={() => <ArrowIcon />}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value="" disabled className={styles.lessonInput}>
                  Choose location
                </MenuItem>
                {TypesList.map((t) => (
                  <MenuItem key={t} className={styles.capitalize} value={t}>
                    {t}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={`${styles.inputLink} ${styles.margin}`}>
            <img src={IconLink} alt="link icon" />
            <input
              value={link}
              onChange={handleSetLink}
              type="text"
              placeholder="Link to your activity"
            />
          </div>
          {!editEventData && (
            <div className={`${styles.customSelect} ${styles.margin}`}>
              <img src={IconTick} alt="arrow icon" />
              <FormControl className={classes.formControl}>
                <Select
                  value={repeatability}
                  onChange={handleChangeRepeatability}
                  displayEmpty
                  className={classes.selectEmpty}
                  inputProps={{ 'aria-label': 'Without label' }}
                  IconComponent={() => <ArrowIcon />}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                  }}
                >
                  <MenuItem value="">Does Not Repeat</MenuItem>
                  <MenuItem value="daily">Daily</MenuItem>
                  <MenuItem value="weekly">Weekly</MenuItem>
                  <MenuItem value="bi-weekly">Bi-weekly</MenuItem>
                </Select>
              </FormControl>
            </div>
          )}
          <div className={styles.errorsBlock}>
            {!_.isEmpty(errorMessages) &&
              errorMessages.map((err: string) => (
                <span className="error-message">{err}</span>
              ))}
          </div>
          <div className={styles.modalWrapper}>
            {editEventData?.repeat && (
              <ReccModal
                trigger={
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenEdit();
                    }}
                    className={`${buttons.buttomPrimary}  ${styles.ButtonWidth}`}
                    type="button"
                  >
                    Save
                  </button>
                }
                modalContent={
                  <RecurringModal
                    modalType="edit"
                    action={handleSetEditType}
                    closeModal={handleOpenEdit}
                  />
                }
                isOpen={isReccurrentEditOpen}
                modalOpen={handleOpenEdit}
              />
            )}
            {(!editEventData || !editEventData.repeat) && (
              <button
                onClick={() => handleSubmit()}
                className={`${buttons.buttomPrimary}  ${styles.ButtonWidth}`}
                type="button"
              >
                Save
              </button>
            )}
            {editEventData?.repeat && (
              <ReccModal
                trigger={
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenDelete();
                    }}
                    className={styles.modalTrash}
                  >
                    <img src={Delete} alt="delete event" />
                  </button>
                }
                modalContent={
                  <RecurringModal
                    modalType="delete"
                    action={handleDeleteEvent}
                    closeModal={handleOpenDelete}
                  />
                }
                isOpen={isReccurrentDeleteOpen}
                modalOpen={handleOpenDelete}
              />
            )}
            {editEventData && !editEventData.repeat && (
              <button
                type="button"
                onClick={() => handleDeleteEvent()}
                className={styles.modalTrash}
              >
                <img src={Delete} alt="delete event" />
              </button>
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default connect(mapStateToProps, {
  clearEventsErrors: clearEventsErrorsAction,
})(Modal);
